import { getCurrentAddressFromLatLong, IAddress } from '@partiu/api/landing/api';
import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';

interface ILocationContext {
  latitude?: number;
  longitude?: number;
  address?: IAddress;
  isLocated?: boolean;
  hasLocationEnabled?: boolean;
  isLoading: boolean;
}

const defaultLocationContextData: ILocationContext = {
  isLoading: true,
};

const LocationContext = createContext(defaultLocationContextData);

export function LocationProvider({ children }: PropsWithChildren) {
  const [data, setData] = useState(defaultLocationContextData);

  useEffect(() => {
    if (data.latitude || data.longitude) return;

    navigator.geolocation.getCurrentPosition(
      (geo) => {
        setData({
          ...data,
          hasLocationEnabled: true,
          latitude: geo.coords.latitude,
          longitude: geo.coords.longitude,
        });
      },
      (error) => {
        console.error('Location:', error.message, error);

        setData({
          ...data,
          isLoading: false,
          hasLocationEnabled: false,
          isLocated: false,
        });
      },
      {
        enableHighAccuracy: true,
        timeout: 30000, // 0.5 minutes
        maximumAge: 15000,
      }
    );
  }, []);

  useEffect(() => {
    if (!data.longitude || !data.latitude || data.address) return;

    getCurrentAddressFromLatLong(data.latitude, data.longitude).then((address) =>
      setData({ ...data, address: address, isLoading: false, isLocated: true })
    );
  }, [data]);

  return <LocationContext.Provider value={data}>{children}</LocationContext.Provider>;
}

export function useLocationContext() {
  return useContext(LocationContext);
}
